import { QuoteModel } from '@_types/molecules';
import { getModifiers } from '@helpers/functions';
import RequireCss from '@helpers/RequireCss';
import Icon from '@atoms/icons/Icon';

const Quote = (model: QuoteModel) => {
  const { text, companyName, name, groupId } = model;
  const styleModifiers = getModifiers(model, 'kf-o-quote');

  return (
    <div className={styleModifiers} data-quote-group-id={groupId}>
      <div className="kf-container">
        <div className="row center-xs">
          <div className="kf-o-quote__quote-open col-xs-12 col-sm-2 col-md-1 col-gutter-lr">
            <Icon iconPath="#kf-open-quote" viewBoxHeight={78} viewBoxWidth={106} />
          </div>
          <div className="kf-o-quote__content col-xs-10 col-sm-8 col-md-6 col-lg-4 col-gutter-lr">
            <div>
              <h5 className="kf-o-quote__text">{text}</h5>
              <div className="kf-o-quote__bottom">
                <div className="kf-o-quote__bottom__content">
                  <p className="kf-o-quote__name">{name}</p>
                  <p className="kf-o-quote__company-name">{companyName}</p>
                </div>
              </div>
            </div>
          </div>
          <div className="kf-o-quote__quote-close col-xs-2 col-sm-2 col-md-1">
            <Icon iconPath="#kf-close-quote" viewBoxHeight={78} viewBoxWidth={104} />
          </div>
        </div>
      </div>
      <RequireCss path="b-quote" />
    </div>
  );
};

export default Quote;
